import script from "./OpenSourceLicenses.vue?vue&type=script&setup=true&lang=js"
export * from "./OpenSourceLicenses.vue?vue&type=script&setup=true&lang=js"

import "./OpenSourceLicenses.vue?vue&type=style&index=0&id=4734c3b4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4734c3b4"]])

export default __exports__